export default "__VITE_ASSET__adc12ad2__"